import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as WalletImage } from './images/wallet.svg';
import styles from './Wallet.module.scss';
import { humanize } from '../../../../utils/format';

const Wallet = ({ value = 0 }) => (
  <div className={styles.wallet}>
    <WalletImage />
    <span className={styles.value}>{humanize(value)}</span>
  </div>
);

Wallet.propTypes = {
  value: PropTypes.number,
};

export default Wallet;
